import AOS from 'aos';

window.addEventListener('load', () => {
    setTimeout(() => {
        AOS.init({
            once: true,
            offset: 100,
            duration: 700,
            delay: 300
        });
    }, 100);
});

$(function() {
    function initParallax(targets, speed, y, smooth) {
        $(targets).attr('data-speed', speed)
            .attr('data-parallax', `{"y" : ${y}, "smoothness": ${smooth}}`);
    }

    function hoverHighlights(highlights, highlightsText) {
        $.each($(highlightsText), function (idx, val) {
            let h = $(val).outerHeight();
            val.style.marginBottom = `-${h}px`;
        });

        $(highlights).hover(function () {
            let $text = $(this).find('.js-highlights-item-text');
            $text.css('marginBottom', 0);
        }, function () {
            let $text = $(this).find('.js-highlights-item-text'),
                h = $text.outerHeight();
            $text.css('marginBottom', `-${h}px`);
        });
    }

    function hoverMoreLocations(items) {
        items.forEach(item => {
            item.addEventListener('mousemove', function () {
                let $locTitle = document.querySelectorAll('.js-more-loc-title'),
                    $locCount = document.querySelectorAll('.js-more-loc-count'),
                    $locImg = this.dataset.bgUrl;
                $('.js-more-loc-bg').css('background-image', `url(${$locImg})`).fadeIn(100);
                $locTitle.forEach(title => {
                    title.classList.add('hover');
                });
                $locCount.forEach(count => {
                    count.classList.add('hover');
                });
                this.classList.add('hover-current');
            });
            item.addEventListener('mouseleave', function () {
                let $locTitle = document.querySelectorAll('.js-more-loc-title'),
                    $locCount = document.querySelectorAll('.js-more-loc-count');
                $('.js-more-loc-bg').hide();
                $locTitle.forEach(title => {
                    title.classList.remove('hover');
                });
                $locCount.forEach(count => {
                    count.classList.remove('hover');
                });
                this.classList.remove('hover-current');
            });
        });
    }

    initParallax(`
        .single-post .gallery .gallery-item img,
        .single .content-single-post__content p > img
    `, .02, 20, 30);

    hoverHighlights(`
        .js-highlights-item,
        .js-highlights-item-text
    `);

    hoverMoreLocations(document.querySelectorAll('.js-more-loc-item'));
});